import React from 'react';
import ErrorPage from '../../pages/404';

/*
 *   ErrorBoundary Component is meant to be used at a layout/page level
 *   Error is caught and sent to Sentry.io kindur-marketing environment
 *   Page is redirected to error page with custom formatted data
 */

export default class ErrorBoundary extends React.Component<{}, ErrorState> {
  public static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  public static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.path !== prevState.path) {
      return { path: nextProps.path, hasError: false, error: false };
    } else { return null; }
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, path: props.path };
  }

  public componentWillUnmount() {
    this.setState({hasError: false, error: null});
  }

  public componentDidCatch(error, info) {
    this.setState({ hasError: true, error });
  }

  public render() {
    const pageData = {
      title: 'Oops! An Error Occurred.',
      body: 'Get back to retiring fearlessly.',
      cta: {
        copy: 'Back to Home',
        link: '/'
      }
    };
    if (this.state.hasError) {
      return <ErrorPage data={pageData} pageContext={null} />;
    } else {
      return this.props.children;
    }
  }
}

interface ErrorState { hasError: boolean; error: {}; path: string; }
